<!-- start section -->
<section
  id="home"
  [hidden]="showEnquiry"
  class="big-section cover-background background-position-center-bottom"
  style="background-image: url('assets/images/home-seo-agency-bg-01.jpg')"
>
  <div class="container">
    <div
      class="row align-items-center h-720px lg-h-550px md-h-550px xs-h-750px"
    >
      <div class="col-12 col-xl-7 col-md-7 sm-margin-40px-bottom">
        <h1
          class="alt-font font-weight-700 text-uppercase letter-spacing-minus-1px"
        >
          Your <span class="text-gradient-magenta-orange-2">Trusted</span>
        </h1>
        <h1
          class="alt-font font-weight-700 text-uppercase margin-25px-bottom letter-spacing-minus-1px"
        >
          Delivery <span class="text-gradient-magenta-orange-2">Partner</span>
        </h1>
        <!-- <h5 class="alt-font font-weight-600 text-medium-slate-blue text-uppercase margin-5px-bottom">Receive your free</h5>
                <h1 class="alt-font font-weight-700 text-uppercase text-gradient-magenta-orange-2 margin-25px-bottom letter-spacing-minus-1px">Seo report</h1> -->
        <p class="w-90 text-large line-height-30px">
          If your item fits in a Satchel choose satchels for an economical
          shipping rate.
        </p>
        <div class="row">
          <div
            class="col-12 tab-style-06 wow animate__fadeIn"
            data-wow-delay="0.2s"
          >
            <!-- start tab navigation -->
            <ul class="nav nav-tabs text-center justify-content-center">
              <li class="nav-item">
                <a
                  class="alt-font nav-link text-uppercase active"
                  data-bs-toggle="tab"
                  href="#satchels"
                  (click)="setSelectedTab('satchel')"
                  >Satchels</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="alt-font nav-link text-uppercase"
                  data-bs-toggle="tab"
                  href="#parcels"
                  (click)="setSelectedTab('parcel')"
                  >Parcels</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="alt-font nav-link text-uppercase"
                  data-bs-toggle="tab"
                  href="#track"
                  (click)="setSelectedTab('track')"
                  >Track</a
                >
              </li>
            </ul>
            <!-- end tab navigation -->
            <div class="tab-content">
              <!-- start tab content -->
              <div class="tab-pane med-text fade in active show" id="satchels">
                <form [formGroup]="step1SatchelForm" id="step1SatchelForm">
                  <div class="row mb-3 mt-3">
                    <label for="inputEmail3" class="col-sm-3 col-form-label"
                      >PO Box</label
                    >
                    <div class="col-sm-9">
                      <!-- <input type="text" class="form-control" id="inputEmail3"> -->
                      <select
                        id="satchel-size"
                        class="form-control"
                        formControlName="sendToPOBox"
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="inputEmail3" class="col-sm-3 col-form-label">
                      From
                      <button
                        *ngIf="isLoggedIn$"
                        (click)="searchAddressBook('from', 'satchel')"
                        class="btn btn-sm btn-outline-warning btn-rounded d-table d-lg-inline-block mx-1 float-end"
                      >
                        <i class="feather icon-feather-search"></i>
                      </button>
                    </label>
                    <div class="col-sm-9">
                      <div class="row g-1 mb-1">
                        <div class="col">
                          <select
                            id="satchel-size"
                            class="form-control"
                            formControlName="fromCountry"
                            (change)="
                              setFromCountry($event.target.value, 'satchel')
                            "
                          >
                            <option value="AU">AUSTRALIA</option>
                          </select>
                        </div>
                        <div class="col">
                          <ng-select
                            formControlName="from"
                            [minTermLength]="postalCodeMinLengthTerm"
                            [loading]="fromPostalCodeLoading"
                            [typeahead]="fromPostalCodeInput$"
                          >
                            <ng-option
                              *ngFor="let item of fromPostalCodes$ | async"
                              [value]="item"
                            >
                              {{
                                item.suburb +
                                  ", " +
                                  item.state +
                                  ", " +
                                  item.postcode +
                                  ", " +
                                  item.country_id
                              }}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="inputEmail3" class="col-sm-3 col-form-label">
                      To
                      <button
                        *ngIf="isLoggedIn$"
                        (click)="searchAddressBook('to', 'satchel')"
                        class="btn btn-sm btn-outline-warning btn-rounded d-table d-lg-inline-block mx-1 float-end"
                      >
                        <i class="feather icon-feather-search"></i>
                      </button>
                    </label>
                    <div class="col-sm-9">
                      <div class="row g-1 mb-1">
                        <div class="col">
                          <select
                            id="satchel-size"
                            class="form-control"
                            formControlName="toCountry"
                            (change)="
                              setToCountry($event.target.value, 'satchel')
                            "
                          >
                            <option
                              *ngFor="let country of countries$"
                              [value]="country.id"
                            >
                              {{ country?.country_name }}
                            </option>
                          </select>
                        </div>
                        <div class="col">
                          <ng-select
                            formControlName="to"
                            [minTermLength]="postalCodeMinLengthTerm"
                            [loading]="toPostalCodeLoading"
                            [typeahead]="toPostalCodeInput$"
                          >
                            <ng-option
                              *ngFor="let item of toPostalCodes$ | async"
                              [value]="item"
                            >
                              {{
                                item.suburb +
                                  ", " +
                                  item.state +
                                  ", " +
                                  item.postcode
                              }}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row mb-3">
                                        <label for="inputEmail3" class="col-sm-2 col-form-label">Date</label>
                                        <div class="col-sm-10">
                                            <input type="date" class="form-control" id="inputEmail3">
                                        </div>
                                    </div> -->
                  <div formGroupName="package" class="row mb-3">
                    <label for="inputEmail3" class="col-sm-3 col-form-label"
                      >Size</label
                    >
                    <div class="col-sm-9">
                      <!-- <input type="text" class="form-control" id="inputEmail3"> -->
                      <!-- <select id="satchel-size" class="form-control" formControlName="packageName" (change)="setSatchelSize($event.target.value)">
                                                <option *ngFor=" let size of satchelSize$" [value]='size.name'>
                                                    {{ size?.name }} <small>(L:  {{ size.length }} | W: {{ size.width }} | H: {{ size.height }}) cm</small>
                                                </option>
                                            </select> -->
                      <div class="row g-1 gy-1">
                        <div class="col">
                          <input
                            type="number"
                            placeholder="Weight (KG)"
                            class="form-control"
                            formControlName="weight"
                          />
                        </div>
                        <div class="col">
                          <input
                            type="number"
                            placeholder="Length (CM)"
                            class="form-control"
                            formControlName="length"
                          />
                        </div>
                        <div class="col">
                          <input
                            type="number"
                            placeholder="Width (CM)"
                            class="form-control"
                            formControlName="width"
                          />
                        </div>
                        <div class="col">
                          <input
                            type="number"
                            placeholder="Height (CM)"
                            class="form-control"
                            formControlName="height"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-grid mx-auto">
                    <button
                      type="submit"
                      class="btn btn-block btn-round-edge btn-gradient-magenta-orange-2 text-white"
                      (click)="getQuote('satchel')"
                    >
                      <div
                        *ngIf="quotesLoading"
                        class="spinner-border text-white mx-2"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      Get Quote
                    </button>
                  </div>
                </form>
              </div>
              <!-- end tab content -->
              <!-- start tab content -->
              <div class="tab-pane med-text fade in" id="parcels">
                <form [formGroup]="step1ParcelForm" id="step1ParcelForm">
                  <div class="row mb-3 mt-3">
                    <label for="inputEmail3" class="col-sm-3 col-form-label"
                      >PO Box</label
                    >
                    <div class="col-sm-9">
                      <!-- <input type="text" class="form-control" id="inputEmail3"> -->
                      <select
                        id="satchel-size"
                        class="form-control"
                        formControlName="sendToPOBox"
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="inputEmail3" class="col-sm-3 col-form-label">
                      From
                      <button
                        *ngIf="isLoggedIn$"
                        (click)="searchAddressBook('from', 'parcel')"
                        class="btn btn-sm btn-outline-warning btn-rounded d-table d-lg-inline-block mx-1 float-end"
                      >
                        <i class="feather icon-feather-search"></i>
                      </button>
                    </label>
                    <div class="col-sm-9">
                      <div class="row g-1 mb-1">
                        <div class="col">
                          <select
                            id="satchel-size"
                            class="form-control"
                            formControlName="fromCountry"
                            (change)="
                              setFromCountry($event.target.value, 'satchel')
                            "
                          >
                            <option value="AU">AUSTRALIA</option>
                          </select>
                        </div>
                        <div class="col">
                          <ng-select
                            formControlName="from"
                            [minTermLength]="postalCodeMinLengthTerm"
                            [loading]="fromPostalCodeLoading"
                            [typeahead]="fromPostalCodeInput$"
                          >
                            <ng-option
                              *ngFor="let item of fromPostalCodes$ | async"
                              [value]="item"
                            >
                              {{
                                item.suburb +
                                  ", " +
                                  item.state +
                                  ", " +
                                  item.postcode +
                                  ", " +
                                  item.country_id
                              }}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="inputEmail3" class="col-sm-3 col-form-label">
                      To
                      <button
                        *ngIf="isLoggedIn$"
                        (click)="searchAddressBook('to', 'parcel')"
                        class="btn btn-sm btn-outline-warning btn-rounded d-table d-lg-inline-block mx-1 float-end"
                      >
                        <i class="feather icon-feather-search"></i>
                      </button>
                    </label>
                    <div class="col-sm-9">
                      <div class="row g-1 mb-1">
                        <div class="col">
                          <select
                            id="satchel-size"
                            class="form-control"
                            formControlName="toCountry"
                            (change)="
                              setToCountry($event.target.value, 'satchel')
                            "
                          >
                            <option
                              *ngFor="let country of countries$"
                              [value]="country.id"
                            >
                              {{ country?.country_name }}
                            </option>
                          </select>
                        </div>
                        <div class="col">
                          <ng-select
                            formControlName="to"
                            [minTermLength]="postalCodeMinLengthTerm"
                            [loading]="toPostalCodeLoading"
                            [typeahead]="toPostalCodeInput$"
                          >
                            <ng-option
                              *ngFor="let item of toPostalCodes$ | async"
                              [value]="item"
                            >
                              {{
                                item.suburb +
                                  ", " +
                                  item.state +
                                  ", " +
                                  item.postcode +
                                  ", " +
                                  item.country_id
                              }}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row mb-3">
                                        <label for="inputEmail3" class="col-sm-2 col-form-label">Date</label>
                                        <div class="col-sm-10">
                                            <input type="date" class="form-control" id="inputEmail3">
                                        </div>
                                    </div> -->
                  <div class="row mb-3">
                    <label for="inputEmail3" class="col-sm-3 col-form-label"
                      >Size</label
                    >
                    <div class="col-sm-9" formArrayName="packages">
                      <div
                        class="mb-3"
                        *ngFor="
                          let package of parcelPackages().controls;
                          let packageIndex = index
                        "
                      >
                        <div [formGroup]="package">
                          <div class="row g-1 mb-1">
                            <!-- <div class="col">
                                                            <select id="satchel-size" class="form-control" formControlName="parcelType" (change)="setParcelSize(packageIndex, $event.target.value)">
                                                                <option *ngFor=" let size of parcelSizes$" [value]='size.name'>
                                                                    {{ size?.name }}
                                                                </option>
                                                            </select>
                                                        </div> -->
                            <div class="col">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Content"
                                formControlName="content"
                              />
                            </div>
                          </div>
                          <div class="row g-1 mb-1">
                            <div class="col">
                              <div class="checkbox">
                                <input
                                  type="checkbox"
                                  class="mx-2"
                                  id="dangerous"
                                  formControlName="is_dg"
                                />
                                <label for="dangerous" class="text-danger"
                                  >Does this package contains lithium ion
                                  battery?</label
                                >
                              </div>
                            </div>
                          </div>
                          <div class="row g-1 mb-1">
                            <div class="col">
                              <label
                                for="dangerous"
                                class="text-warning"
                                *ngIf="
                                  parcelPackages().controls[packageIndex].get(
                                    'is_dg'
                                  ).value
                                "
                                >Max 2 equipments per package & Max 2 packages
                                per shipment</label
                              >
                            </div>
                          </div>
                          <div class="row g-1 gy-1">
                            <div class="col">
                              <input
                                type="number"
                                placeholder="Quantity"
                                class="form-control"
                                formControlName="quantity"
                              />
                            </div>
                            <div class="col">
                              <input
                                type="number"
                                placeholder="Weight (KG)"
                                class="form-control"
                                formControlName="weight"
                              />
                            </div>
                            <div class="col">
                              <input
                                type="number"
                                placeholder="Length (CM)"
                                class="form-control"
                                [value]="size?.length"
                                formControlName="length"
                              />
                            </div>
                            <div class="col">
                              <input
                                type="number"
                                placeholder="Width (CM)"
                                class="form-control"
                                [value]="size?.width"
                                formControlName="width"
                              />
                            </div>
                            <div class="col">
                              <input
                                type="number"
                                placeholder="Height (CM)"
                                class="form-control"
                                [value]="size?.height"
                                formControlName="height"
                              />
                            </div>
                            <div class="col">
                              <div class="d-grid mx-auto">
                                <button
                                  type="button"
                                  *ngIf="packageIndex === 0"
                                  (click)="addParcelPackage()"
                                  class="btn btn-round-edge btn-gradient-magenta-orange-2"
                                >
                                  <i
                                    class="feather icon-feather-plus align-middle text-white"
                                  ></i>
                                </button>
                                <button
                                  type="button"
                                  *ngIf="packageIndex >= 1"
                                  class="btn btn-round-edge btn-gradient-magenta-orange-2"
                                  (click)="removeParcelPackage(packageIndex)"
                                >
                                  <i
                                    class="feather icon-feather-minus align-middle text-white"
                                  ></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-grid mx-auto">
                    <button
                      type="submit"
                      class="btn btn-round-edge btn-gradient-magenta-orange-2 text-white"
                      (click)="getQuote('parcel')"
                    >
                      <div
                        *ngIf="quotesLoading"
                        class="spinner-border text-white mx-2"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      Get Quote
                    </button>
                  </div>
                </form>
              </div>
              <!-- end tab content -->
              <!-- start tab content -->
              <div class="tab-pane med-text fade in" id="track">
                <form>
                  <div
                    class="newsletter-email position-relative d-inline-block w-95 margin-20px-top margin-30px-bottom"
                  >
                    <input
                      #trackNo
                      class="border-radius-5px large-input bg-white border-color-white box-shadow-large m-0 required"
                      name="track_no"
                      placeholder="Enter your tracker number"
                      type="text"
                    />
                    <!-- <input type="hidden" name="redirect" value=""> -->
                    <button
                      class="btn border-transperent"
                      type="button"
                      (click)="searchByTrackNo(trackNo.value)"
                    >
                      <div
                        *ngIf="trackingFlag"
                        class="spinner-border text-white mx-2"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <i
                        *ngIf="!trackingFlag"
                        class="far fa-paper-plane icon-extra-small text-gradient-magenta-orange-2 left-icon"
                      ></i>
                    </button>
                    <div
                      class="form-results border-radius-5px position-absolute d-none"
                    ></div>
                  </div>
                </form>
              </div>
              <!-- end tab content -->
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-5 col-md-5 text-lg-end">
        <img src="assets/img/package.png" alt="" />
      </div>
    </div>
  </div>
  <!-- Search Address Book Modal -->
  <div
    class="modal fade"
    id="searchAddressBookModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Address Book</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body" *ngIf="isLoggedIn$">
          <search-book-address
            (selectRecord)="selectRecordOfAddressBook($event)"
          ></search-book-address>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- end section -->

<section
  id="enquiry-result"
  *ngIf="showEnquiry"
  class="sub-page-heading-section bg-light-gray wow animate__fadeIn"
  data-wow-delay="0.4s"
>
  <div class="container">
    <div class="row justify-content-center" *ngIf="enquiryType === 'package'">
      <div class="col-12 col-md-6 text-center margin-1-half-rem-bottom">
        <div class="margin-10px-bottom">
          <i
            (click)="closeEnquiry()"
            role="button"
            class="line-icon-Arrow-OutLeft icon-large text-orange"
          ></i>
        </div>
        <!-- <button type="button" class="btn-close line-height-unset mb-4"  aria-label="Close"></button> -->
        <h5
          class="alt-font text-extra-dark-gray font-weight-500 letter-spacing-minus-1px"
        >
          Quotes
          <span
            class="alt-font margin-10px-bottom text-uppercase text-medium font-weight-500"
            >({{ preQuoteData?.Package_type }})</span
          >
        </h5>
        <div>
          <span
            class="alt-font margin-10px-bottom text-uppercase text-medium font-weight-500"
            ><b>From: </b>{{ preQuoteData?.Pickup?.suburb }},
            {{ preQuoteData?.Pickup?.postcode }}</span
          >
          <span
            class="alt-font margin-10px-bottom text-uppercase text-medium font-weight-500 padding-45px-lr lg-padding-35px-lr xs-padding-20px-left"
            ><b>To: </b>{{ preQuoteData?.Delivery?.suburb }},
            {{ preQuoteData?.Delivery?.postcode }}</span
          >
        </div>
        <span
          class="alt-font margin-10px-bottom d-block text-uppercase text-medium font-weight-500"
          *ngFor="let package of preQuoteData.Packages; index as packageIndex"
        >
          {{ package?.name }}
          <small
            >(L: {{ package?.length }} | W: {{ package?.width }} | H:
            {{ package?.height }}) cm</small
          >
        </span>
      </div>
    </div>
    <div class="row justify-content-center" *ngIf="enquiryType === 'tracking'">
      <div class="col-12 col-md-6 text-center margin-1-half-rem-bottom">
        <div class="margin-10px-bottom">
          <i
            (click)="closeEnquiry()"
            role="button"
            class="line-icon-Arrow-OutLeft icon-large text-orange"
          ></i>
        </div>
        <h5
          class="alt-font text-extra-dark-gray font-weight-500 letter-spacing-minus-1px"
        >
          Tracking Details
        </h5>
        <span
          class="alt-font margin-10px-bottom d-block text-uppercase text-medium font-weight-500"
          ><b>Tracking No: </b>{{ trackingNo }}</span
        >
      </div>
    </div>
    <div class="row justify-content-center" *ngIf="enquiryType === 'package'">
      <!-- start fancy text box item -->
      <div
        class="col-12 col-lg-12 col-md-12 col-sm-12 margin-30px-bottom xs-margin-15px-bottom"
        *ngFor="let quote of offeredQuotes.quotes; index as quoteIndex"
      >
        <div
          class="feature-box feature-box-left-icon-middle padding-3-half-rem-all bg-white box-shadow-small box-shadow-extra-large-hover border-radius-6px lg-padding-1-half-rem-lr xs-padding-2-rem-all"
        >
          <div
            class="feature-box-icon margin-40px-lr lg-margin-35px-lr xs-margin-20px-right xs-no-margin-left"
          >
            <img
              [src]="environment.apiUrl + quote.icon"
              alt="service icon"
              width="200"
              class="float-sm-left mt-sm-1"
            />
          </div>
          <div
            class="feature-box-content border-left border-color-medium-gray padding-45px-lr lg-padding-35px-lr xs-padding-20px-left xs-no-padding-right last-paragraph-no-margin"
          >
            <p
              class="text-extra-dark-gray alt-font font-weight-500"
              *ngIf="quote.distance > 0"
            >
              Distance: {{ quote.distance }} Km
            </p>
            <p>APPROX: {{ quote.eta }} *</p>
          </div>
          <div
            class="feature-box-content border-left border-color-medium-gray padding-45px-lr lg-padding-35px-lr xs-padding-20px-left xs-no-padding-right last-paragraph-no-margin"
          >
            <h2
              class="alt-font no-margin-bottom text-gradient-orange-pink font-weight-600 letter-spacing-minus-1px"
            >
              ${{ quote.total }}
            </h2>
            <p class="text-extra-dark-gray alt-font font-weight-500">
              ${{ quote.gst }} inc GST
            </p>
            <!-- <button class="btn btn-round-edge btn-gradient-magenta-orange-2 text-white" data-bs-toggle="modal" data-bs-target="#regFormModal">Book Service</button> -->
            <button
              class="btn btn-round-edge btn-gradient-magenta-orange-2 text-white"
              [routerLink]="
                ['/bookings/add/' + offeredQuotes.reference_no] +
                '/' +
                quote.service
              "
            >
              Book Service
            </button>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-lg-12 col-md-12 col-sm-12 margin-30px-bottom xs-margin-15px-bottom"
      >
        <div class="alert alert-info">
          <h4>DISCLAIMER</h4>
          <p>
            Delivery times may vary depending on suburb/state and territory. The
            national business day delivery network operates between capital
            cities (excluding Darwin and Perth betwen CBD only) and some major
            cities.
          </p>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" *ngIf="enquiryType === 'tracking'">
      <!-- end fancy text box item -->
      <div
        class="col-12 col-lg-12 col-md-12 col-sm-12 margin-30px-bottom xs-margin-15px-bottom"
        *ngFor="let tracking of trackingData; index as trackingIndex"
      >
        <div
          class="feature-box feature-box-left-icon-middle padding-3-half-rem-all bg-white box-shadow-small box-shadow-extra-large-hover border-radius-6px lg-padding-1-half-rem-lr xs-padding-2-rem-all"
        >
          <div
            *ngIf="tracking.signature"
            class="feature-box-icon margin-40px-lr lg-margin-35px-lr xs-margin-20px-right xs-no-margin-left"
          >
            <img
              [src]="tracking.signature"
              alt="signature"
              width="200"
              class="float-sm-left mt-sm-1"
            />
          </div>
          <div
            class="feature-box-content border-left border-color-medium-gray padding-45px-lr lg-padding-35px-lr xs-padding-20px-left xs-no-padding-right last-paragraph-no-margin"
          >
            <p class="text-extra-dark-gray alt-font font-weight-500">
              {{ tracking.description }}
            </p>
            <p class="text-extra-dark-gray alt-font font-weight-300 text-muted">
              {{ tracking.date }}
            </p>
          </div>
        </div>
      </div>
      <p
        *ngIf="trackingData?.length == 0"
        class="text-extra-dark-gray alt-font font-weight-500 text-center"
      >
        No Tracking Information
      </p>
    </div>
  </div>
  <!-- Registration Modal -->
  <!-- <div class="modal fade" id="regFormModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Please enter your details</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form [formGroup]="regForm" id="regForm">
                        <div class="row">
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">First Name</span>
                                </label>
                                <input type="text" formControlName="firstname" class="form-control mt-2">
                            </div>
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">Last Name</span>
                                </label>
                                <input type="text" formControlName="lastname" class="form-control mt-2">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">Company Name</span>
                                </label>
                                <input type="text" formControlName="company_name" class="form-control mt-2">
                            </div>
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">Contanct No</span>
                                </label>
                                <input type="text" formControlName="contact_no" class="form-control mt-2">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">Address Line 1</span>
                                </label>
                                <input type="text" formControlName="address_1" class="form-control mt-2">
                            </div>
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">Address Line 2</span>
                                </label>
                                <input type="text" formControlName="address_2" class="form-control mt-2">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">Suburb</span>
                                </label>
                                <input type="text" formControlName="suburb" class="form-control mt-2">
                            </div>
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">State</span>
                                </label>
                                <input type="text" formControlName="state" class="form-control mt-2">
                            </div>
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">Postal Code</span>
                                </label>
                                <input type="text" formControlName="postcode" class="form-control mt-2">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">Email</span>
                                </label>
                                <input type="text" formControlName="email" class="form-control mt-2">
                            </div>
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">username</span>
                                </label>
                                <input type="text" formControlName="username" class="form-control mt-2">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">Password</span>
                                </label>
                                <input type="text" formControlName="pass" class="form-control mt-2">
                            </div>
                            <div class="col px-1 mb-2">
                                <label for="input1" class="ms-2 position-absolute" style="margin-top: -0.25rem !important">
                                    <span class="h6 small bg-white text-muted px-1">Confirm Password</span>
                                </label>
                                <input type="text" formControlName="confirm_pass" class="form-control mt-2">
                            </div>
                        </div>
                        <div class="row">
                            <button type="submit" class="btn btn-medium btn-round-edge btn-gradient-magenta-orange-2 text-white" (click)="registerCustomer()">
                                Register
                            </button>
                        </div>
                        
                    </form>
                </div>
            </div>
        </div>
    </div> -->
</section>
<!-- start section -->
<section
  class="padding-eight-bottom border-bottom border-color-extra-light-gray"
>
  <div class="container">
    <div class="row justify-content-center">
      <div
        class="col-12 col-lg-9 col-sm-9 text-center margin-7-rem-bottom md-margin-6-rem-bottom sm-margin-4-rem-bottom wow animate__fadeIn"
      >
        <span
          class="alt-font font-weight-600 text-uppercase text-gradient-magenta-orange-2 d-block letter-spacing-1px margin-20px-bottom sm-margin-10px-bottom"
          >How it Works</span
        >
        <h5 class="alt-font font-weight-300 text-medium-slate-blue">
          Sending out your packages has never been easier. Work out if your
          package can fit in a Satchel or it requires a Parcel. Choose the
          desired packaging type. Enter the pick up and Delivery address. Choose
          or enter size of package and hit the GET QUOTE button. Choose from
          various options provided and proceed with order. Receive your shipping
          labels by email, attach them on the package and let us pick them up
          for you. Its that easy! Get Started Now!
        </h5>
      </div>
    </div>
    <div class="row justify-content-center">
      <!-- start progress step item -->
      <div
        class="col-10 col-lg-3 col-sm-6 text-center process-step-style-03 simple md-margin-5-rem-bottom wow animate__fadeIn"
        data-wow-delay="0.2s"
      >
        <div class="process-step-item">
          <div class="process-step-item-box">
            <span class="process-step-item-box-bfr bg-medium-gray"></span>
            <div class="process-step-icon">
              <span class="process-step-number text-white font-weight-500">
                <span class="process-step-number-bfr bg-light-orange"></span
                >1<span
                  class="process-step-number-afr bg-gradient-magenta-orange-2"
                ></span>
              </span>
            </div>
            <div class="process-content last-paragraph-no-margin">
              <span
                class="alt-font d-inline-block font-weight-500 text-medium-slate-blue text-uppercase margin-10px-bottom"
                >Create Your Account</span
              >
              <p></p>
            </div>
          </div>
        </div>
      </div>
      <!-- end progress step item -->
      <!-- start progress step item -->
      <div
        class="col-10 col-lg-3 col-sm-6 text-center process-step-style-03 simple md-margin-5-rem-bottom wow animate__fadeIn"
        data-wow-delay="0.3s"
      >
        <div class="process-step-item">
          <div class="process-step-item-box">
            <span class="process-step-item-box-bfr bg-medium-gray"></span>
            <div class="process-step-icon">
              <span class="process-step-number text-white font-weight-500">
                <span class="process-step-number-bfr bg-light-orange"></span
                >2<span
                  class="process-step-number-afr bg-gradient-magenta-orange-2"
                ></span>
              </span>
            </div>
            <div class="process-content last-paragraph-no-margin">
              <span
                class="alt-font d-inline-block font-weight-500 text-medium-slate-blue text-uppercase margin-10px-bottom"
                >Get Your quote</span
              >
              <p></p>
            </div>
          </div>
        </div>
      </div>
      <!-- end progress step item -->
      <!-- start progress step item -->
      <div
        class="col-10 col-lg-3 col-sm-6 text-center process-step-style-03 simple xs-margin-5-rem-bottom wow animate__fadeIn"
        data-wow-delay="0.4s"
      >
        <div class="process-step-item">
          <div class="process-step-item-box">
            <span class="process-step-item-box-bfr bg-medium-gray"></span>
            <div class="process-step-icon">
              <span class="process-step-number text-white font-weight-500">
                <span class="process-step-number-bfr bg-light-orange"></span
                >3<span
                  class="process-step-number-afr bg-gradient-magenta-orange-2"
                ></span>
              </span>
            </div>
            <div class="process-content last-paragraph-no-margin">
              <span
                class="alt-font d-inline-block font-weight-500 text-medium-slate-blue text-uppercase margin-10px-bottom"
                >Start Shipment</span
              >
              <p></p>
            </div>
          </div>
        </div>
      </div>
      <!-- end progress step item -->
    </div>
  </div>
</section>
<!-- end section -->
<!-- start section -->
<section>
  <div class="container">
    <div class="row align-items-center justify-content-center">
      <div
        class="col-10 col-md-4 text-center sm-margin-30px-bottom wow animate__fadeIn"
        data-wow-delay="0.1s"
      >
        <img
          class="md-padding-30px-right"
          src="assets/img/delivery.png"
          alt=""
        />
      </div>
      <div
        class="col-10 col-xl-7 col-lg-7 offset-lg-1 col-md-7 ps-lg-0 text-center text-md-start wow animate__fadeIn"
        data-wow-delay="0.3s"
      >
        <h3
          class="alt-font font-weight-600 text-gradient-magenta-orange-2 letter-spacing-1px d-inline-block margin-20px-bottom sm-margin-10px-bottom"
        >
          We help small businesses to send parcels in much easier, affordable
          and reliable way.
        </h3>
        <h5 class="alt-font font-weight-500 text-medium-slate-blue"></h5>
        <p></p>
      </div>
    </div>
  </div>
</section>
<!-- end section -->
<!-- start section -->
<section
  class="cover-background h-550px lg-h-500px xs-h-auto"
  style="background-image: url('assets/images/home-seo-agency-bg-02.jpg')"
>
  <div class="container">
    <div class="row align-items-center">
      <div
        class="col-12 col-xl-3 col-lg-4 text-center text-lg-start md-margin-40px-bottom wow animate__fadeIn"
        data-wow-delay="0.1s"
      >
        <span
          class="alt-font font-weight-500 text-medium-slate-blue letter-spacing-1px d-inline-block text-uppercase margin-10px-bottom sm-margin-10px-bottom"
        ></span>
        <h4
          class="alt-font font-weight-600 text-gradient-magenta-orange-2 mb-0"
        >
          We offer best services
        </h4>
      </div>
      <!-- start feature box item -->
      <div
        class="col-12 col-lg-2 offset-xl-1 col-md-3 col-sm-6 text-center wow animate__zoomIn"
        data-wow-delay="0.3s"
      >
        <div
          class="feature-box feature-box-shadow h-100 padding-2-rem-lr padding-35px-tb lg-padding-1-rem-lr"
        >
          <div class="feature-box-icon">
            <i
              class="feather icon-feather-monitor icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
            ></i>
          </div>
          <div class="feature-box-content last-paragraph-no-margin">
            <span
              class="alt-font font-weight-500 d-block text-medium-slate-blue line-height-24px"
              >Easily Place Order</span
            >
          </div>
          <div class="feature-box-overlay bg-white border-radius-6px"></div>
        </div>
      </div>
      <!-- end feature box item -->
      <!-- start feature box item -->
      <div
        class="col-12 col-lg-2 col-md-3 col-sm-6 text-center wow animate__zoomIn"
        data-wow-delay="0.4s"
      >
        <div
          class="feature-box feature-box-shadow h-100 padding-2-rem-lr padding-35px-tb lg-padding-1-rem-lr"
        >
          <div class="feature-box-icon">
            <i
              class="feather icon-feather-clock icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
            ></i>
          </div>
          <div class="feature-box-content last-paragraph-no-margin">
            <span
              class="alt-font font-weight-500 d-block text-medium-slate-blue line-height-24px"
              >Fast Delivery</span
            >
          </div>
          <div class="feature-box-overlay bg-white border-radius-6px"></div>
        </div>
      </div>
      <!-- end feature box item -->
      <!-- start feature box item -->
      <div
        class="col-12 col-lg-2 col-md-3 col-sm-6 text-center wow animate__zoomIn"
        data-wow-delay="0.5s"
      >
        <div
          class="feature-box feature-box-shadow h-100 padding-2-rem-lr padding-35px-tb lg-padding-1-rem-lr"
        >
          <div class="feature-box-icon">
            <i
              class="feather icon-feather-dollar-sign icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
            ></i>
          </div>
          <div class="feature-box-content last-paragraph-no-margin">
            <span
              class="alt-font font-weight-500 d-block text-medium-slate-blue line-height-24px"
              >Affordable</span
            >
          </div>
          <div class="feature-box-overlay bg-white border-radius-6px"></div>
        </div>
      </div>
      <!-- end feature box item -->
      <!-- start feature box item -->
      <div
        class="col-12 col-lg-2 col-md-3 col-sm-6 text-center wow animate__zoomIn"
        data-wow-delay="0.6s"
      >
        <div
          class="feature-box feature-box-shadow h-100 padding-2-rem-lr padding-35px-tb lg-padding-1-rem-lr"
        >
          <div class="feature-box-icon">
            <i
              class="feather icon-feather-thumbs-up icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
            ></i>
          </div>
          <div class="feature-box-content last-paragraph-no-margin">
            <span
              class="alt-font font-weight-500 d-block text-medium-slate-blue line-height-24px"
              >Reliable</span
            >
          </div>
          <div class="feature-box-overlay bg-white border-radius-6px"></div>
        </div>
      </div>
      <!-- end feature box item -->
    </div>
  </div>
</section>
<!-- end section -->

<!-- start section -->
<section class="overlap-height md-no-padding-top xs-padding-40px-top">
  <div class="container">
    <div
      class="row align-items-center justify-content-center overlap-gap-section"
    >
      <!-- <div class="col-12 col-lg-5 col-md-10 text-center text-lg-end md-margin-30px-bottom wow animate__fadeIn" data-wow-delay="0.2s">
                <img src="assets/img/delivery.png" alt=""/>
            </div> -->
      <div class="row col-12 col-lg-12 offset-lg-0 col-md-10 ps-lg-0">
        <!-- start feature box item -->
        <div
          class="row col-12 col-lg-4 feature-box feature-box-left-icon border-bottom border-color-medium-gray wow animate__fadeInRight"
          data-wow-delay="0.2s"
        >
          <div class="feature-box-icon">
            <i
              class="d-inline-block line-icon-Sand-watch2 icon-medium text-gradient-magenta-orange-2"
            ></i>
            <h4
              class="d-inline-block px-3 alt-font text-gradient-magenta-orange-2 font-weight-500 margin-5px-bottom text-medium-slate-blue"
            >
              Parcel Delivery
            </h4>
          </div>
          <div class="feature-box-content last-paragraph-no-margin">
            <!-- <p class="w-85 xs-w-100">Lorem ipsum dolor amet consectetur adipiscing elit sed do eiusmod tempor incididunt.</p> -->
            <ul class="list-style-02 p-0">
              <li>
                <span class="text-extra-dark-gray font-weight-600 px-2"
                  >Economy
                </span>
                Delivery Within 3-4 Business Days
              </li>
              <li>
                <span class="text-extra-dark-gray font-weight-600 px-2"
                  >Express
                </span>
                Delivery Within 1-2 Business Days
              </li>
              <li class="p-0">
                <i
                  class="feather icon-feather-check icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
                ></i>
                Door to Door Delivery
              </li>
              <li class="m-0">
                <i
                  class="feather icon-feather-check icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
                ></i>
                Tracking & Insurance Included
              </li>
              <li class="p-0">
                <i
                  class="feather icon-feather-check icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
                ></i>
                Proof of Signature on Deliveries
              </li>
            </ul>
          </div>
        </div>
        <!-- end feature box item -->
        <!-- start feature box item -->
        <div
          class="row col-12 col-lg-4 feature-box feature-box-left-icon border-bottom border-color-medium-gray wow animate__fadeInRight"
          data-wow-delay="0.4s"
        >
          <div class="feature-box-icon">
            <i
              class="d-inline-block line-icon-Money-Bag icon-medium text-gradient-magenta-orange-2"
            ></i>
            <h4
              class="d-inline-block px-3 alt-font text-gradient-magenta-orange-2 font-weight-500 margin-5px-bottom text-medium-slate-blue"
            >
              Satchel Delivery
            </h4>
          </div>
          <div class="feature-box-content last-paragraph-no-margin">
            <!-- <p class="w-85 xs-w-100">Lorem ipsum dolor amet consectetur adipiscing elit sed do eiusmod tempor incididunt.</p> -->
            <ul class="list-style-02 p-0">
              <li>
                <span class="text-extra-dark-gray font-weight-600 px-2"
                  >Economy
                </span>
                Delivery Within 3-4 Business Days
              </li>
              <li>
                <span class="text-extra-dark-gray font-weight-600 px-2"
                  >Express
                </span>
                Delivery Within 1-2 Business Days
              </li>
              <li>
                <span class="text-extra-dark-gray font-weight-500"
                  ><i
                    class="feather icon-feather-check icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
                  ></i
                ></span>
                Door to Door Delivery
              </li>
              <li>
                <span class="text-extra-dark-gray font-weight-500"
                  ><i
                    class="feather icon-feather-check icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
                  ></i
                ></span>
                Tracking & Insurance Included
              </li>
              <li>
                <span class="text-extra-dark-gray font-weight-500"
                  ><i
                    class="feather icon-feather-check icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
                  ></i
                ></span>
                Proof of Signature on Deliveries
              </li>
            </ul>
          </div>
        </div>
        <!-- end feature box item -->
        <!-- start feature box item -->
        <div
          class="row col-12 col-lg-4 feature-box feature-box-left-icon md-no-padding-bottom wow animate__fadeInRight"
          data-wow-delay="0.6s"
        >
          <div class="feature-box-icon">
            <i
              class="d-inline-block line-icon-Male icon-medium text-gradient-magenta-orange-2"
            ></i>
            <h4
              class="d-inline-block px-3 alt-font text-gradient-magenta-orange-2 font-weight-500 margin-5px-bottom text-medium-slate-blue"
            >
              Same Day Delivery
            </h4>
          </div>
          <div class="feature-box-content last-paragraph-no-margin">
            <!-- <p class="w-85 xs-w-100">Lorem ipsum dolor amet consectetur adipiscing elit sed do eiusmod tempor incididunt.</p> -->
            <ul class="list-style-02 p-0">
              <li>
                <span class="text-extra-dark-gray font-weight-600 px-2"
                  >Economy
                </span>
                Delivery Within 3-4 Business Days
              </li>
              <li>
                <span class="text-extra-dark-gray font-weight-600 px-2"
                  >Express
                </span>
                Delivery Within 1-2 Business Days
              </li>
              <li>
                <span class="text-extra-dark-gray font-weight-600 px-2"
                  >VIP
                </span>
                Delivery Within 1-2 Hours
              </li>
              <li>
                <span class="text-extra-dark-gray font-weight-500"
                  ><i
                    class="feather icon-feather-check icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
                  ></i
                ></span>
                Door to Door Delivery
              </li>
              <li>
                <span class="text-extra-dark-gray font-weight-500"
                  ><i
                    class="feather icon-feather-check icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
                  ></i
                ></span>
                Tracking & Insurance Included
              </li>
              <li>
                <span class="text-extra-dark-gray font-weight-500"
                  ><i
                    class="feather icon-feather-check icon-extra-medium text-gradient-magenta-orange-2 margin-20px-bottom d-inline-block"
                  ></i
                ></span>
                Proof of Signature on Deliveries
              </li>
            </ul>
          </div>
        </div>
        <!-- end feature box item -->
      </div>
    </div>
  </div>
</section>
<!-- end section -->

<!-- start section -->
<section
  class="parallax bg-gradient-light-orange-light-pink wow animate__fadeIn"
>
  <div class="container">
    <!-- <div class="z-index-6 overlap-section">
            <form action="email-templates/subscribe-newsletter.php" method="post">
                <div class="bg-gradient-magenta-orange-2 border-radius-5px padding-55px-tb margin-10-rem-bottom md-margin-8-rem-bottom md-padding-40px-all xs-padding-20px-lr sm-margin-7-rem-bottom wow animate__flipInX" data-wow-delay="0.1s">
                    <div class="row align-items-center justify-content-center">
                        <div class="col-12 col-lg-2 text-center text-lg-end md-margin-30px-bottom sm-margin-20px-bottom">
                            <h6 class="alt-font font-weight-500 text-white mb-0">Get your free quote today?</h6>
                        </div>
                        <div class="col-12 col-md-5 sm-margin-20px-bottom">
                            <input class="border-radius-4px large-input bg-white border-color-white mb-0 margin-20px-right required" name="email" placeholder="Enter your email address" type="email">
                        </div>
                        <div class="col-12 col-md-auto text-center">
                            <input type="hidden" name="redirect" value="">
                            <button type="submit" class="btn btn-extra-large btn-dark-gray btn-round-edge btn-slide-right-bg submit"><i class="far fa-envelope icon-extra-small left-icon"></i>Get started</button>
                            <div class="form-results border-radius-4px position-absolute left-0px d-none"></div>
                        </div>
                    </div>
                </div>
            </form>
        </div> -->
    <div class="row justify-content-center">
      <div
        class="col-12 col-xl-6 col-lg-7 col-md-8 wow animate__fadeIn"
        data-wow-delay="0.3s"
      >
        <div class=" ">
          <div
            class="margin-1-rem-bottom align-self-center text-center w-100 md-margin-2-rem-bottom xs-no-margin-bottom"
          >
            <!-- <img alt="" src="assets/images/home-seo-agency-quote.png" class="margin-30px-bottom"> -->
            <span
              class="alt-font text-extra-large font-weight-500 text-extra-dark-gray d-block margin-20px-bottom"
              >Best Choice for Delivery</span
            >
            <p
              class="text-extra-medium margin-20px-bottom w-85 d-inline-block text-extra-dark-gray line-height-32px lg-w-90 md-w-100"
            >
              At ParcelPlus we have teamed up with major courier services and
              independent metro courier services to service you with highly
              effective, reliable and prompt courier services at lower prices.
              We have been servicing small and medium size businesses and
              understand the need for great delivery partners for todays
              businesses. We take pride in our services to our valuable clients
              and deliver a high- quality service at all times. ParcelPlus –
              Your Trusted Delivery Partner.
            </p>
            <!-- <span class="text-gradient-magenta-orange-2 alt-font font-weight-500 letter-spacing-1px text-uppercase margin-20px-bottom d-inline-block">Jemas Dossan</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- end section -->
